<template>
    <app-layout>
        <div class="flex">
            <div class="max-w-7xl mx-auto">
                <h1 class="text-2xl mb-4">
                    {{ $t("incidents.title_update", $attrs.incident.title) }}
                </h1>
                <edit-incident
                    :incident="$attrs.incident"
                    :all-projects="$page.props.allProjects"
                    :error-bags="$attrs.errorBags"
                ></edit-incident>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import EditIncident from "@/Components/EditIncident";

export default {
    components: {
        EditIncident,
        AppLayout,
    },
};
</script>
